import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import { HashRouter as Router, Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import HomePage from "./Components/Homepage/HomePage";
import AboutUs from "./Components/AboutPage/AboutUs";
import ContactUs from "./Components/ContactPage/ContactUs";
import ScrollToTop from "./Components/ScrollToTop";
import DepartmentPage from "./Components/DepartmentPage/DepartmentPage";
import DoctorProfilePage from "./Components/DoctorProfilePage/DoctorProfilePage";
import { DataProvider } from "./context/DataContext";
import UnderConstruction from "./Components/UnderConstruction";

const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <DataProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/department/:slug" element={<DepartmentPage />} />
            <Route path="/doctorprofile/:slug" element={<DoctorProfilePage />} />
            {/* Catch-all route for invalid links */}
            <Route path="*" element={<UnderConstruction />} />
          </Routes>
        </Router>
      </DataProvider>
    </QueryClientProvider>
  );
};

export default App;
